var s=class extends Error{constructor(e,i){super(e),this.invalidReason=i}};export{s as a};
//# sourceMappingURL=chunk-6Q2O5G3J.mjs.map